export default __webpack_public_path__ + "bf2d440b3a42ea78a998ccd32eb09d88.ttf";